import { notificationAPI } from '@/utils/api'

export default {
  namespaced: true,
  
  state: {
    notifications: [],
    unreadCount: 0,
    loading: false,
    error: null
  },
  
  mutations: {
    SET_NOTIFICATIONS(state, notifications) {
      state.notifications = notifications
    },
    SET_UNREAD_COUNT(state, count) {
      state.unreadCount = count
    },
    ADD_NOTIFICATION(state, notification) {
      state.notifications.unshift(notification)
      if (!notification.isRead) {
        state.unreadCount++
      }
    },
    MARK_AS_READ(state, notificationId) {
      const notification = state.notifications.find(n => n.id === notificationId)
      if (notification && !notification.isRead) {
        notification.isRead = true
        state.unreadCount = Math.max(0, state.unreadCount - 1)
      }
    },
    MARK_ALL_AS_READ(state) {
      state.notifications.forEach(notification => {
        notification.isRead = true
      })
      state.unreadCount = 0
    },
    REMOVE_NOTIFICATION(state, notificationId) {
      const index = state.notifications.findIndex(n => n.id === notificationId)
      if (index !== -1) {
        const notification = state.notifications[index]
        if (!notification.isRead) {
          state.unreadCount = Math.max(0, state.unreadCount - 1)
        }
        state.notifications.splice(index, 1)
      }
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_ERROR(state, error) {
      state.error = error
    }
  },
  
  actions: {
    async getNotifications({ commit }, empId) {
      // Guard against undefined or null empId
      if (!empId) {
        console.warn('getNotifications called with undefined or null empId')
        return { model: [], didError: false }
      }
      
      commit('SET_LOADING', true)
      
      try {
        const response = await notificationAPI.mobileGetNotifications(empId)
        if (response.model) {
          commit('SET_NOTIFICATIONS', response.model)
        }
        return response
      } catch (error) {
        commit('SET_ERROR', error.message)
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    },
    
    async markAsRead({ commit }, notificationId) {
      commit('SET_LOADING', true)
      
      try {
        const response = await notificationAPI.mobileMarkNotificationRead(notificationId)
        commit('MARK_AS_READ', notificationId)
        return response
      } catch (error) {
        commit('SET_ERROR', error.message)
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    },
    
    async getUnreadCount({ commit }, empId) {
      if (!empId) {
        console.warn('getUnreadCount called with undefined or null empId')
        return { model: 0, didError: false }
      }
      
      try {
        const response = await notificationAPI.mobileGetUnreadCount(empId)
        if (response.model !== undefined) {
          commit('SET_UNREAD_COUNT', response.model)
        }
        return response
      } catch (error) {
        commit('SET_ERROR', error.message)
        throw error
      }
    },
    
    async markAllAsRead({ commit }) {
      commit('SET_LOADING', true)
      
      try {
        const response = await notificationAPI.markAllAsRead()
        commit('MARK_ALL_AS_READ')
        return response
      } catch (error) {
        commit('SET_ERROR', error.message)
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    },
    
    async deleteNotification({ commit }, notificationId) {
      commit('SET_LOADING', true)
      
      try {
        const response = await notificationAPI.deleteNotification(notificationId)
        commit('REMOVE_NOTIFICATION', notificationId)
        return response
      } catch (error) {
        commit('SET_ERROR', error.message)
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    },
    
    clearError({ commit }) {
      commit('SET_ERROR', null)
    }
  },
  
  getters: {
    notifications: state => state.notifications,
    unreadCount: state => state.unreadCount,
    loading: state => state.loading,
    error: state => state.error,
    unreadNotifications: state => state.notifications.filter(n => !n.isRead),
    readNotifications: state => state.notifications.filter(n => n.isRead),
    recentNotifications: state => state.notifications.slice(0, 10),
    hasUnread: state => state.unreadCount > 0
  }
} 